/**
 * 静态资源地址。
 *
 * ★ 2026-09-05：图片改从 OSS 取（主公令：卸掉服务器下行带宽）。
 *   `VITE_ASSET_BASE` 由构建时注入；没注入就回落 `BASE_URL`，
 *   本机开发与「不走 CDN」的部署形态行为不变。
 *
 * ★ 为什么不直接写死 OSS 域名：换 CDN、回退到本地、开发调试都要改代码，
 *   而这类地址一旦散落在多个组件里就再也收不回来了。
 */
export function assetUrl(path: string): string {
  const base = (import.meta.env.VITE_ASSET_BASE as string | undefined) || import.meta.env.BASE_URL;
  return base.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
}
